import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { DeviceConfiguredApplicationsEffects } from './device-configured-applications.effects';
import { deviceConfiguredApplicationsReducer } from './device-configured-applications.reducer';

export const provideDeviceConfiguredApplicationsStore = () => [
  provideState('device-configured-applications', deviceConfiguredApplicationsReducer),
  provideEffects([DeviceConfiguredApplicationsEffects]),
];
